import { useSearchTypeFromRoute } from '@aibees/elephant/hooks';
import { SearchType } from '@aibees/elephant/types';

export function useGetAvatarBasedOnSearchType() {
  const type = useSearchTypeFromRoute();

  let srcList: string[] = [];

  if (type === SearchType.Company)
    srcList = [
      '/assets/avatar/company1.png',
      '/assets/avatar/company2.png',
      '/assets/avatar/company3.png',
      '/assets/avatar/company4.png',
      '/assets/avatar/company5.png',
    ];

  if (type === SearchType.People)
    // Ordered left-to-right; AvatarGroup renders the first entry leftmost.
    // The design specifies the order right-to-left as: Anousheh Ansari,
    // Paul Graham, Claire Hughes Johnson, Michael Seibel, Yamini Rangan, Garry Tan.
    srcList = [
      '/assets/avatar/garry-tan.png',
      '/assets/avatar/yamini-rangan.png',
      '/assets/avatar/michael-seibel.png',
      '/assets/avatar/claire-hughes-johnson.png',
      '/assets/avatar/paul-graham.png',
      '/assets/avatar/anousheh-ansari.png',
    ];
  return srcList;
}
